import { block } from './block';
import type { AdditionalClasses, Modifier } from './types';

/**
 * Creates a BEM element class generator function for the given base class.
 * Returns a function that generates BEM element class names with optional modifiers.
 *
 * @param baseClass  The base BEM block class name (e.g., 'button', 'card')
 * @param elem       The BEM element name (e.g., 'icon', 'title')
 * @param modifier   Optional BEM modifier ()
 * @returns combined BEM element class name
 *
 * @example
 * element('my-button', 'icon'); // 'my-button__icon'
 * element('my-button', 'icon', { active: true }); // 'my-button__icon my-button__icon--active'
 */
export function element(baseClass: string, elem: string, additionalClasses: AdditionalClasses): string;
export function element(
    baseClass: string,
    elem: string,
    modifiers?: Modifier,
    additionalClasses?: AdditionalClasses,
): string;
export function element(
    baseClass: string,
    elem: string,
    modifiersOrAdditionalClasses?: Modifier | AdditionalClasses,
    additionalClasses?: AdditionalClasses,
) {
    return block(`${baseClass}__${elem}`, modifiersOrAdditionalClasses as Modifier, additionalClasses);
}
